<template>
	<div class="add-store">
		<div class="box">
			<div class="title">اطلاعات مشتری</div>
			<div class="row mt-3">
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="نام مشتری" v-model="editData.name" inputType="text" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="تلفن" v-model="editData.phone" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="کد مشتری" v-model="editData.code" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="کد مشتری" v-model="editData.customer_code" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<label for="html">نوع مشتری:</label>
					<select style="width: 100%" v-model="editData.category.id" class="search-input">
						<option v-for="outlet in outletCat" :value="outlet.id" :key="outlet.id">
							<span>{{ outlet.verbose_name }}</span>
						</option>
					</select>
				</div>
			</div>
		</div>
		<div class="box">
			<div class="title">اطلاعات صاحب مشتری</div>
			<div class="row mt-3">
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="نام و نام خانودگی" v-model="editData.owner_name" inputType="text" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="موبایل" v-model="editData.mobile_phone" />
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="کد ملی" v-model="editData.owner_national_code" />
				</div>
			</div>
		</div>
		<div class="box">
			<div class="title">محل مشتری</div>
			<div class="row mt-3">
				<div class="col-lg-6 col-sm-12">
					<label for="html">استان:</label>
					<select
						style="width: 100%"
						@change="getCityOnChange"
						v-model="editData.city.province"
						class="search-input"
					>
						<option
							v-for="province in provinceLists"
							:value="province.id"
							:key="`province-` + province.id"
						>
							{{ province.name }}
						</option>
					</select>
				</div>
				<div class="col-lg-6 col-sm-12">
					<label for="html">شهر:</label>
					<select style="width: 100%" v-model="editData.city.id" class="search-input">
						<option v-for="city in cityLists" :value="city.city.id" :key="`city-` + city.city.id">
							{{ city.city.name }}
						</option>
					</select>
				</div>
				<div class="col-lg-6 col-sm-12">
					<Materialnput label="کد پستی" v-model="editData.postal_code" />
				</div>
				<div v-if="Object.keys(mapData).length > 0" class="col-lg-12 col-sm-12">
					<Materialnput label="آدرس" v-model="mapData.address" />
				</div>
			</div>
			<div class="map-text">لطفا محل مشتری را بر روی نقشه انتخاب کنید.</div>
			<Map :defaultLat="editData.latitude" :defaultLng="editData.longitude" @child-event="handleChildEvent" />
			<div class="d-flex justify-content-end mt-4">
				<button class="accept"  @click="submitBtn">ذخیره</button>
			</div>
		</div>
	</div>
</template>
<script>
import Materialnput from '../../components/MaterialInput/indx.vue';
import Map from '../../components/Map/index.vue';
export default {
	components: {
		Materialnput,
		Map,
	},
	data() {
		return {
			nameModel: '',
			telModel: '',
			storeCodeModel: '',
			customersCodeModel: '',
			userNameModel: '',
			mobileModel: '',
			nationalCodeModel: '',
			cityLists: [],
			provinceLists: [],
			pickCity: '',
			pickProvince: '',
			postalCodeModel: '',
			pickStore: '',
			outletCat: [],
			mapData: {},
			text: false,
			editData: {},
			selectedkCity: '',
		};
	},

	mounted() {
		// this.getRoles();
		this.getProvince();
		this.getOutletCat();
		this.getCity();
		this.getdataEditMode();
		this.selectedkCity = this.editData.city.id;

	},
	computed: {
		
	},
	methods: {
		async getCity() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST +
					'?city__province=' +
					this.selectedkCity +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				'city:', res.data;
				this.cityLists = res.data;
			}
		},
		async getdataEditMode() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.OUTLET_MORE_INFO +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.editData = res.data;
			}
		},
		async getOutletCat() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.OUTLET_CAT + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.outletCat = res.data;
			}
		},
		async getProvince() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.provinceLists = res.data;
			}
		},
		getCityOnChange() {
			this.selectedkCity = this.editData.city.province;
			this.getCity();
		},
		handleChildEvent(data) {
			this.mapData = data;
		},
		async submitBtn() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const data = {
				name: this.editData.name,
				address: this.mapData.address,
				city: this.editData.city.id,
				longitude: this.mapData.geom.coordinates[0],
				latitude: this.mapData.geom.coordinates[1],
				postal_code: this.editData.postal_code,
				phone: this.editData.phone,
				mobile_phone: this.mobile_phone,
				owner_national_code: this.editData.owner_national_code,
				owner_name: this.editData.owner_name,
				period: 1,
				visit_count: 0,
				code: this.editData.code,
				customer_code: this.editData.customer_code,
				category: this.editData.category.id,
				is_active: true,
				is_visiting: false,
				more_info: [],
			};
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.OUTLET_MORE_INFO + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.ORDER,
				data,
			);
			res;
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'اطلاعات مشتری با موفقیت ذخیره شد.',
				});
				setTimeout(() => {
					this.$router.push({ name: 'storeMngListAll' });
				}, 2000);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.add-store {
	padding: 32px 50px;
	.box {
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
	}
	.title {
		margin-bottom: 8px;
	}
	.search-input {
		text-indent: 10px;
		height: 40px;
		border: 1px solid #c4c4c4;
		padding: 0 9px;
		border-radius: 8px;
		font-family: 'IRANYekanfa' !important;
		border-radius: 8px;
		margin: 8px 0;
	}
	.accept {
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		padding: 8px 40px;
		border: none !important;
		margin-left: 10px;
		border-radius: 8px;
	}
	.map-text {
		display: flex;
		justify-content: center;
		width: 100%;
		background: rgba(244, 245, 247, 0.8);
		border-radius: 8px 8px 0 0;
		margin-bottom: -20px;
		position: sticky;
		z-index: 9999;
		font-size: 14px;
	}
	.accept:disabled {
		background: #c4c4c4;
	}
}
</style>
